import { render, staticRenderFns } from "./Supportive.vue?vue&type=template&id=18222db1&scoped=true&"
var script = {}
import style0 from "./Supportive.vue?vue&type=style&index=0&id=18222db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18222db1",
  null
  
)

export default component.exports